module.exports = "/images/China.png?897037fc1ec3a40264dcfc2d1a5fe8be";